module.exports = __webpack_public_path__ + "img/RSS Feed.465138f5.png";